import { render } from "./AboutPage.vue?vue&type=template&id=882bc032"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"
script.render = render

export default script